module.exports = __webpack_public_path__ + "static/media/igi_auction_normal.ca2e2e5b.png";